export default __webpack_public_path__ + "static/media/Boarder.c6750165.png";